import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>(() => ({
  registerSuccessTitle: {
    fontWeight: 500,
  },
  registerStatus: {
    margin: "20px 0",
    lineHeight: "1.8rem",
  },
  addToCalender: {
    textTransform: "none",
  },
  addToCalenderButton: {
    marginBottom: "50px",
  },
}));
